export const getCategories = function (state) {
    return state.categories
}

export const isLoading = function (state) {
    return state.loading
}

export const isLoadingProducts = function (state) {
    return state.loadingProducts
}

export const getSearchResults = function (state) {
    return state.searchResults
}

export const isSearching = function (state) {
    return state.searching
}

export const getOpenedcategorie = function(state){
    return state.openedCategorie
}

export const getOpenedCategoryInfo = (state) => {
    let category = state.categories[state.openedCategorie]
    if (category){
        return  {id: category.id, title: category.title, parent_id: category.parent_id}
    } else {
        return category;
    }
}

export const getParentCategory = function(state){
    return function (id) {
       if(id){
           let category = Object.values(state.categories).filter(category => id.includes(category.id))
           if (category){
               return  category.map(cat => { return {id: cat.id, title: cat.title, parent_id: cat.parent_id} } )
           } else {
               return category;
           }
       }
       return []

    }
}

export const getAllProducts = function (state) {
    let products = []
    Object.values(state.categories).forEach(function (category) {
        products = [...products, ...category.products]
    })
    return products
}

export const getBundlesList = function (state) {
    return state.bundles
}

export const isLoadingBundles = function (state) {
    return state.loadingBundles
}

export const isPacksMode = function (state) {
    return state.packsMode
}

export const getOpenedCategorieProduct = function (state) {
    let products = []

    if (state.openedCategorie){
        let category = state.categories[state.openedCategorie] || {products: []}
        products = category.products
    }else {
        Object.values(state.categories).forEach(function (category) {
            products = [...products, ...category.products]
        })
    }

    return  products;
}


